export enum EPermission {
  ManageUsers = 'manage:users',
  ManageTenants = 'manage:tenants',
  AnonymizePatients = 'anonymize:patients',
  ReopenConsults = 'reopen:consults',
  ManageAnnouncements = 'manage:announcements',
  CurateHelpFeedback = 'curate:help-feedback',
}
